import deepEqual from "deep-equal";

export default function useHasChanges({ initialValues, values }) {
  if (!values) {
    return false;
  }
  console.log('What are they', initialValues, values);
  return !deepEqual(initialValues, values, { strict: false });
};
